var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotBroken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 80",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E32752",
    d: "M35.162 79.649c-1.807-.258-2.043-7.847-1.936-11.61l7.42 1.936c-1.076 3.332-3.678 9.932-5.484 9.674Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3160",
    d: "M75.904 75.146c-1.611.966-6.44-4.506-8.652-7.363l6.538-6.759c1.376 4.305 3.725 13.156 2.114 14.122Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.417,
    cy: 42.864,
    fill: "#FFBD23",
    rx: 9.355,
    ry: 8.707,
    transform: "rotate(-6.258 10.417 42.864)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.116,
    cy: 41.805,
    fill: "#E32752",
    rx: 11.613,
    ry: 16.768,
    transform: "rotate(-6.258 17.116 41.805)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.355,
    cy: 8.707,
    fill: "#FFED8A",
    rx: 9.355,
    ry: 8.707,
    transform: "scale(-1 1) rotate(4.869 -337.955 -1154.724)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.129,
    cy: 8.707,
    fill: "#FFBD23",
    rx: 6.129,
    ry: 8.707,
    transform: "scale(-1 1) rotate(4.869 -338.922 -1131.964)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.613,
    cy: 16.768,
    fill: "#FF3160",
    rx: 11.613,
    ry: 16.768,
    transform: "scale(-1 1) rotate(4.869 -241.62 -1097.428)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.646,
    cy: 37.728,
    fill: "url(#b)",
    rx: 38.387,
    ry: 37.728
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFED8A",
    fillRule: "evenodd",
    d: "M47.42 75.325c19.69-1.61 35.161-17.828 35.161-37.597 0-19.769-15.47-35.986-35.161-37.597A39.576 39.576 0 0 1 50.646 0c21.2 0 38.387 16.892 38.387 37.728 0 20.837-17.187 37.729-38.387 37.729-1.087 0-2.163-.045-3.226-.132Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.343 6.338c.461-.303.93-.597 1.404-.88 5.023 5.025 11.793 16.18 11.051 33.083a1.444 1.444 0 0 1-1.189 1.361c-3.073.539-8.004 1.148-13.34 1.307-4.984.15-10.372-.093-14.94-1.178a37.502 37.502 0 0 1-.066-1.676c4.451 1.127 9.865 1.394 14.958 1.242 5.173-.154 9.96-.739 12.972-1.26.694-16.702-6.161-27.462-10.85-32ZM89.02 38.73a37.861 37.861 0 0 0 .007-1.665c-4.504 1.152-10.436 1.71-16.052 1.86-5.705.152-11.006-.12-14.056-.594-.407-9.483 1.285-17.37 3.644-23.296 1.974-4.96 4.396-8.5 6.406-10.467-.497-.266-1-.521-1.51-.766-2.137 2.23-4.49 5.853-6.395 10.637-2.454 6.164-4.19 14.327-3.75 24.103.03.662.51 1.247 1.2 1.358 3.162.51 8.655.794 14.504.638 5.498-.147 11.382-.682 16.001-1.808Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.375,
    cy: 38.125,
    fill: "#000",
    rx: 9.375,
    ry: 16.875,
    transform: "rotate(-15 29.375 38.125)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M39.251 42.078a28.927 28.927 0 0 0-.982-6.358c-.42-1.568-.95-3.05-1.563-4.423-2.545-2.24-6.25-3.19-9.92-2.206-3.669.983-6.402 3.658-7.487 6.87a29.68 29.68 0 0 0 .859 4.612 28.929 28.929 0 0 0 2.328 5.998c2.521 1.973 6.015 2.766 9.477 1.838 3.462-.927 6.092-3.361 7.288-6.33Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5,
    cy: 35.058,
    fill: "#000",
    rx: 8.713,
    ry: 15.103,
    transform: "rotate(7.045 70.5 35.058)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M77.982 41.228c.54-1.569.941-3.286 1.166-5.101.224-1.816.253-3.58.11-5.232-1.459-2.666-4.24-4.644-7.618-5.061-3.379-.418-6.557.823-8.622 3.054a25.2 25.2 0 0 0-1.166 5.101 25.193 25.193 0 0 0-.11 5.232c1.459 2.666 4.24 4.643 7.618 5.06 3.379.419 6.557-.822 8.622-3.053Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.613,
    d: "M45.807 49.086c.322-2.258 4.839-4.839 6.774-.323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M51.936 14.833c-.774-.516-1.613.86-1.936 1.613-.215-.968-1.032-2.645-2.58-1.613-1.936 1.29 1.613 4.837 2.58 4.515.968-.323 2.904-3.87 1.936-4.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15 65-5 4.5 3 3-7 6m6.5-18-4 2M86 8.5l7-7M90 13l4-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.875,
    d: "M25.879 33.505c-2.54 1.788-2.279 5.448-.49 7.988s4.923 2.65 6.967 1.21c2.54-1.789 2.487-4.067.698-6.607-2.159-3.066-7.012-.938-3.96 3.398"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.743,
    d: "M73.358 29.799c2.568 1.32 2.798 4.722 1.478 7.29-1.32 2.569-4.19 3.072-6.257 2.01-2.568-1.32-2.812-3.424-1.493-5.992 1.593-3.1 6.335-1.765 4.082 2.619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 12.105,
    x2: 75.35,
    y1: 0,
    y2: 69.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FFDE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v80H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotBroken);
export default __webpack_public_path__ + "static/media/mascot-broken.cd637ab2.svg";
export { ForwardRef as ReactComponent };